/**
 * @function
 * @name setAllocationCompany
 * @description reducer for action.
 * @param {Object} state  - reducer state
 * @param {Object} action - action context
 * @return {OBJECT} Action context
 */
export const setAllocationCompany = (state, action) => ({
  ...state,
  ...action
});

export const setAllocationInfo = (state, action) => ({
  ...state,
  ...action
});
